import * as React from "react";
import Dispatcher from "../../Dispatcher";
import LoginStore from "../login/stores/LoginStore";
import ChangePasswordView, { IChangePasswordViewProps } from "./views/ChangePasswordView";
import { Container } from "flux/utils";

class ChangePasswordPageContainer extends React.Component<{}, IChangePasswordViewProps>
{
    public render()
    {
        return <ChangePasswordView {...this.state} />;
    }

    public static getStores()
    {
        return [
            LoginStore
        ];
    }

    public static calculateState(prevState)
    {
        const loginLoader = LoginStore.getState().getLoadObject();
        if (!loginLoader.hasValue())
        {
            return {};
        }

        return { 
            loginLoader,
            onChangePassword: ChangePasswordPageContainer.onChangePassword
        };
    }

    private static onChangePassword(newPassword: string)
    {
        Dispatcher.dispatch({
            type: "login/change-password",
            newPassword
        });
    }
}

export default Container.create(ChangePasswordPageContainer);
